(() => {
  "use strict";


  /* =======================================================
     CONFIG
     ======================================================= */

  const PROXY_BASE =
    "/apps/mystery-vault";

  const VAULT_SLUG =
    "vault-001";

  const SESSION_TOKEN_KEY =
    "ml_mystery_vault_session_vault_001";


  /* =======================================================
     INIT
     ======================================================= */

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      init
    );

  } else {
    init();
  }


  function init() {
    const root =
      document.getElementById(
        "ml-mystery-vault"
      );


    if (!root) {
      return;
    }


    let popupTracked =
      false;

    let lastTrackedLock =
      null;


    /* =====================================================
       SEND EVENT
       ===================================================== */

    function trackEvent(
      eventType,
      metadata = {},
      requireSession = false
    ) {
      const sessionToken =
        getSessionToken();


      if (
        requireSession &&
        !sessionToken
      ) {
        return;
      }


      const payload = {
        event_type:
          eventType,

        vault:
          VAULT_SLUG,

        metadata: {
          ...metadata,

          page_path:
            window.location.pathname
        }
      };


      /*
       * shop_clicked requires a valid Vault session.
       * Other public events don't need one.
       */

      if (
        requireSession &&
        sessionToken
      ) {
        payload.session_token =
          sessionToken;
      }


      fetch(
        `${PROXY_BASE}/event`,
        {
          method:
            "POST",

          headers: {
            "Content-Type":
              "application/json"
          },

          credentials:
            "same-origin",

          keepalive:
            true,

          body:
            JSON.stringify(
              payload
            )
        }
      )
        .catch(
          () => {
            /*
             * Analytics must never interrupt
             * the Mystery Vault experience.
             */
          }
        );
    }


    /* =====================================================
       SESSION
       ===================================================== */

    function getSessionToken() {
      try {
        return sessionStorage.getItem(
          SESSION_TOKEN_KEY
        );

      } catch (error) {
        return null;
      }
    }


    /* =====================================================
       POPUP SHOWN
       ===================================================== */

    function trackPopupIfNeeded() {
      if (
        popupTracked ||
        !root.classList.contains(
          "is-open"
        )
      ) {
        return;
      }


      popupTracked =
        true;


      trackEvent(
        "popup_shown",
        {
          source:
            "mystery_vault"
        }
      );
    }


    /*
     * Observe the Vault itself instead of changing
     * the main Vault JS.
     */

    const observer =
      new MutationObserver(
        () => {
          trackPopupIfNeeded();
        }
      );


    observer.observe(
      root,
      {
        attributes:
          true,

        attributeFilter: [
          "class"
        ]
      }
    );


    /*
     * Covers the rare case where the Vault was already
     * open before this script finished initializing.
     */

    trackPopupIfNeeded();


    /* =====================================================
       LOCK SELECTED
       ===================================================== */

    root.addEventListener(
      "click",
      (event) => {
        const lockButton =
          event.target.closest(
            "[data-vault-lock]"
          );


        if (!lockButton) {
          return;
        }


        const lock =
          Number(
            lockButton.dataset
              .vaultLock
          );


        if (
          !Number.isInteger(
            lock
          ) ||
          lock < 1 ||
          lock > 5
        ) {
          return;
        }


        /*
         * Don't record repeated clicks on the exact
         * same lock. If the visitor genuinely changes
         * their selection, the new lock is recorded.
         */

        if (
          lastTrackedLock ===
          lock
        ) {
          return;
        }


        lastTrackedLock =
          lock;


        trackEvent(
          "lock_selected",
          {
            source:
              "mystery_vault",

            lock:
              lock
          }
        );
      },
      true
    );


    /* =====================================================
       SHOP CLICKED
       ===================================================== */

    root.addEventListener(
      "click",
      (event) => {
        const shopLink =
          event.target.closest(
            "[data-vault-shop], [data-vault-free-shop]"
          );


        if (!shopLink) {
          return;
        }


        const isFreeGame =
          shopLink.hasAttribute(
            "data-vault-free-shop"
          );


        let destination =
          shopLink.getAttribute(
            "href"
          ) ||
          "";


        try {
          const destinationUrl =
            new URL(
              shopLink.href,
              window.location.origin
            );


          destination =
            destinationUrl.pathname +
            destinationUrl.search;

        } catch (error) {}


        trackEvent(
          "shop_clicked",
          {
            source:
              isFreeGame
                ? "free_game_reward"
                : "reward",

            destination:
              destination
          },
          true
        );
      },
      true
    );
  }
})();